// extracted by mini-css-extract-plugin
export default {"Container":"Sneaker_Container__o5Fgt"};